import { Object3D, Vector2, Vector3 } from 'three';
import { BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR, PRIMARY_TEXT_COLOR } from '../styleConfig';
import { FuturisticWindow } from './FuturisticWindow';
import { ActionControllerEventName, ButtonComponent, ParentEvent, TextComponent, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class Modal extends ViewerModule {
    constructor() {
        super();
        this.addObject(this.background = new FuturisticWindow({
            size: new Vector2(10, 5),
            radius: 0.3,
            type: 1,
            hasSideImage: false
        }));
        this.addObject(this.header = new TextComponent({
            size: new Vector2(1.1, 1.1),
            pxSize: new Vector2(64, 64),
            text: {
                style: { size: `32px`, family: 'Nunito', weight: '700', color: PRIMARY_TEXT_COLOR.getStyle() },
                value: '',
                lineHeight: 40,
                autoWrappingHorizontal: true,
                autoWrapping: false,
                margin: { bottom: 18 }
            },
            background: { color: 'transparent' }
        }));
        this.header.uiObject.position.z = 0.01;
        this.header.uiObject.position.y = 1.85;
        this.addObject(this.text = new TextComponent({
            size: new Vector2(8, 1),
            pxSize: new Vector2(512, 64),
            text: {
                style: { size: `20px`, family: 'Nunito', weight: '400', color: PRIMARY_TEXT_COLOR.getStyle() },
                value: '',
                autoWrappingHorizontal: false,
                lineHeight: 26,
                align: 'center',
                autoWrapping: true,
                margin: { bottom: 18 }
            },
            background: { color: 'transparent' }
        }));
        this.text.uiObject.position.z = 0.01;
        this.text.uiObject.position.y = -0.3;
        this.button = new ButtonComponent({
            type: 'flat',
            size: new Vector3(6, 6, 1),
            sizePx: new Vector2(256, 256),
            bordRadius: 0.1,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Start'.toUpperCase(),
                lineHeight: 12,
                style: { size: `16px`, color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 10, right: 45, bottom: 10, left: 45 },
            }
        });
        this.button.on(ActionControllerEventName.click, () => this.fire('ok', new ParentEvent('ok')));
        this.buttonsWrapper = new Object3D();
        this.buttonsWrapper.add(this.button.uiObject);
        this.buttonsWrapper.position.z = 0.01;
        this.buttonsWrapper.position.y = -1.6;
        this.addObject(this.buttonsWrapper);
    }
    init(headerText, mainText, buttonText) {
        this.background.init();
        this.header.setText(headerText);
        this.text.setText(mainText);
        this.button.uiObject.visible = !!buttonText;
        if (buttonText)
            this.button.setText(buttonText);
    }
}
